import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetOrganizationByCaseModel = (caseFileModelId: number) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-organization-by-case-model', caseFileModelId],
        queryFn: async () => {
            const response = await zoneApiClient.getOrganizationsByCaseFileModel(caseFileModelId);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve zones.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: !!caseFileModelId,
    });
};
